// extracted by mini-css-extract-plugin
export default {"waitingForTransactionModal":"WaitingForTransactionModal_waitingForTransactionModal__El5gF"};